import { IConsultant, IConsultantJobSearch } from 'wisestep-api';

export const matchingJobQuery = (consultants: IConsultant[]): IConsultantJobSearch[] =>
  consultants.map((consultant) => ({
    id: consultant.id,

    search: consultant.jobHarvestingQuery
      ? consultant.jobHarvestingQuery
      : `"${consultant.jobTitle}"`,
  }));
